import { CmsBlockSlice } from './types'

export const getCmsBlock = (id: string) => (state: any): CmsBlockSlice => {
  return state.cms.cmsBlock[id]
}
